import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Store } from '../../../store/store';
import { Product } from '../../product';

export interface AddProductDialogData {
  store: Store;
}

@Component({
  selector: 'app-add-product-dialogue',
  templateUrl: './add-product-dialogue.component.html',
  styleUrls: ['./add-product-dialogue.component.scss'],
})
export class AddProductDialogueComponent {
  header = 'Ajouter un produit';
  cancelButton = 'Annuler';

  constructor(
    public dialogRef: MatDialogRef<AddProductDialogueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddProductDialogData
  ) {}

  submitProduct(product: Product): void {
    this.dialogRef.close(product);
  }
}
